export default {
  namespaced: true,
  name: 'SLSClienteEnderecoStore',
  state: {
    enderecosCliente: [],
    clienteId: null,
    loading: false,
  },
  mutations: {
    SET_ENDERECOS_CLIENTE(state, enderecos) {
      state.enderecosCliente = enderecos;
    },
    SET_CLIENTE_ID(state, id) {
      state.clienteId = id;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
  },
  getters: {
    enderecosCliente: (state) => state.enderecosCliente,
    clienteId: (state) => state.clienteId,
    loading: (state) => state.loading,
  },
};
